import loadable from '@loadable/component'

export default [
  {
    // 圣诞季2021+2022主页面
    path: '/Xmas2021',
    exact: true,
    component: loadable(
      () => import(/* webpackChunkName: "page-Xmas2021" */ '~/pages/Xmas2021')
    ),
  },
  {
    // 圣诞季2021+2022暴奖弹窗
    path: '/Xmas2021/WholeModal',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-Xmas2021-WholeModal" */ '~/pages/Xmas2021/components/WholeModal'
        )
    ),
  },
]
